import { AppConfig, AppConfigUrl, AuthConfig } from 'app/models/auth-config';
import { TimeZone } from 'app/models/time-zone.model';
import { UserRole } from 'app/models/user-role';
import { AppPrivileges } from '../enums/app-privileges.enum';
import { UserDetail } from 'app/models/user-detail.model';

export class AppConsts {
  public static authConfig: AuthConfig;
  public static webConfig: AppConfigUrl;
  public static appConfig: AppConfig;
  public static roles: UserRole[];
  public static privileges: AppPrivileges[];
  public static locale: string;
  public static localeCurrency: string;
  public static localeCurrencySymbol: string;
  public static loggedInUser: UserDetail;
  public static timeZoneInfo: TimeZone;
  public static picture: string;
}
